import sampleSize from 'lodash/sampleSize';

function generateLoremWords(count: number) {
  const loremWords = [
    'lorem',
    'ipsum',
    'dolor',
    'sit',
    'amet',
    'consectetur',
    'adipiscing',
    'elit',
    'sed',
    'do',
    'eiusmod',
    'tempor',
    'incididunt',
    'ut',
    'labore',
    'et',
    'dolore',
    'magna',
    'aliqua',
  ];

  return sampleSize(loremWords, count);
}

export const mockUser = {
  name: 'Charlie Doe',
  email: 'charliedoe@gmail.com',
  createdOn: new Date().toISOString(),
  status: 'verified',
  mockCustomTextField: generateLoremWords(2),
  mockCustomNumberField: 100,
} as const;

export const placeholderUser = {
  name: '',
  email: '',
  createdOn: '',
  status: '',
} as const;
